import api from "@/config/apiConfig"
import dateMessage from "@/utils/returnDateMessage";

class TicketsController {

  async index(req = {}) {
    try {
      const {
        page = 1,
        search = "",
        departmentIds = [],
        status = "",
        bots = false,
        showAll = false,
        unreadOnly = false,
        limit = 10,
      } = req;
      const params = {
        page,
        limit,
        search,
        departmentIds: JSON.stringify(departmentIds),
        status,
        bots,
        showAll,
        unreadOnly,
      }
      const response = await api.get("/tickets", { params: params });
      response?.data?.tickets?.forEach(item => {
        item.time = dateMessage(item.updatedAt);
        if (item.contact.additionalInfo) {
          item.contact.text = `${item.contact.name} - ${item.contact.additionalInfo}`;
        } else {
          item.contact.text = item.contact.name;
        }

      });
      return response.data;
    } catch (error) {
      console.error("Erro no TicketsController.index: ", error);
      throw error;
    }
  }
  async getOne(ticketId) {
    try {
      const response = await api.get(`/tickets/${ticketId}`)
      return response.data
    } catch (error) {
      console.error("Erro no TicketsController.getOne: ", error)
      throw error
    }
  }
  async update(req) {
    try {
      const response = await api.patch(`/tickets/${req.ticketId}`, req)
      return response.data
    } catch (error) {
      console.error("Erro no TicketsController.update: ", error)
      throw error
    }
  }
  async create(req) {
    try {
      const response = await api.post(`/tickets`, req);
      return response.data;
    } catch (error) {
      console.error("Erro no TicketsController.create: ", error);
      throw error;
    }
  }
  async unread(req = {}) {
    try {
      const { queueIds = [], status = [] } = req;
      const response = await api.get("/tickets/unread/tickets", {
        params: {
          status: status.length > 0 ? JSON.stringify(status) : undefined,
          queueIds: queueIds.length > 0 ? JSON.stringify(queueIds) : undefined,
        }
      });
      return response.data;
    } catch (error) {
      console.error("Erro no TicketsController.unread: ", error.response?.data || error.message || error);
      throw error;
    }
  }

  async summarize(ticketId) {
    try {
      const response = await api.get(`/tickets/${ticketId}/summarize`);
      return response.data;
    } catch (error) {
      console.error("Erro no TicketsController.summarize: ", error);
      throw error;
    }
  }


}

export default new TicketsController();